import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=0b8e453c&scoped=true&"
import script from "./QuestionsView.vue?vue&type=script&lang=ts&"
export * from "./QuestionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e453c",
  null
  
)

export default component.exports